module.exports = __webpack_public_path__ + "img/img-chapter-xl.f928cb5e.jpg";